export default "__VITE_ASSET__58CBkd0h__"